import { render, staticRenderFns } from "./GoalMeter.vue?vue&type=template&id=3deb8a72"
import script from "./GoalMeter.vue?vue&type=script&lang=js"
export * from "./GoalMeter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports